import PropTypes from 'prop-types';

import Flex from 'shopper/components/Flex';
import Price from 'shopper/components/Price';
import Text from 'shopper/components/Text';

const ComparaiPriceDesktop = ({ priceValue, storeTitle }) => (
  <Flex flexDirection="column" mr={10} display={['none', null, 'flex']}>
    <Price size="size3" primaryInfo={priceValue} secondaryInfo="à vista por" />
    <Text size="size3" mt={1}>
      {storeTitle}
    </Text>
  </Flex>
);

ComparaiPriceDesktop.propTypes = {
  priceValue: PropTypes.string.isRequired,
  storeTitle: PropTypes.string.isRequired,
};

export default ComparaiPriceDesktop;
